(function() {
  function trackClick(){
    $("body").on('click', '.js-track-click', function(event) {
      var currentTarget = $(event.currentTarget);
      window.snowplow('trackLinkClick', 'unknown', currentTarget.attr('id'), currentTarget.attr('class').split(/\s+/));
    });
  }

  trackClick();
}());
